module.exports = __webpack_public_path__ + "static/media/2.1eca8bbd.jpg";